import React, { FC } from "react";
import { v4 as uuidv4 } from "uuid";

import { makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import Card, { CardProps } from "./Card";

interface CardListProps {
  title: React.ReactNode;
  items: CardProps[];
}

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    color: theme.palette.primary.main,
  },
}));

const CardList: FC<CardListProps> = ({ title, items }) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="body1" className={classes.title}>
        {title}
      </Typography>
      <Box mt={1}>
        <Grid container spacing={4}>
          {items &&
            items.map((item) => (
              <Grid item xs={12} sm={3} key={uuidv4()}>
                <Card {...item} />
              </Grid>
            ))}
        </Grid>
      </Box>
    </>
  );
};

export default CardList;
